import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { Users } from '@/features/settings/Users';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/settings/users',
  component: Users,
});
